import React, { useEffect, useRef, useState } from "react";
import {
	PageContainer,
	ProForm,
	ProFormDependency,
	ProFormItem,
	ProFormRadio,
	ProFormSelect,
	ProFormText,
	ProFormTimePicker
} from "@ant-design/pro-components";

import { Builder, BuilderProps, Config, ImmutableTree, JsonGroup, Query, Utils as QbUtils } from "../awesome";
import "../awesome/css/styles.scss";
import "./index.less";

import AntdConfig from "../awesome/config/antd";
import { InfoOutlined } from "@ant-design/icons";
import { convertTreeForGo, loadFromTreeForGo } from "../queryBuilder";
import { Cascader, InputNumber, message, Spin, Tag, Button, Space, Divider } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { fetchADAccountList } from "@/api/modules/AdAccount";
import { useTranslation, getI18n } from "react-i18next";

import { getQueryVariable } from "@/utils/util";
import { DefaultOptionType } from "antd/lib/select";
import { fetchCreateStrategy, fetchEditRules, fetchStrategyDetail } from "@/api/modules/strategy";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
// import { conatants, AdGroupFields_Settings, AdFields_Settings, CampaignFields_Settings,AdgroupMostCommon } from "../constants/FBRuleCondField";

const queryBuilderInitialConfig = AntdConfig;

type CascaderOption = {
	value: string | number;
	needExtraParam?: boolean;
	label: string;
	children?: CascaderOption[];
};

type RouterParams = {
	id?: string;
};

type InitValue = {
	strategy_name?: string;
	enable_time_range?: string[];
	advertiser_ids?: string[];
	scope?: string;
	scope_status?: string;
	is_repetitive?: number;
	frequency?: number;
	reportPeriod: string;
};

const defaultQueryBuilderValue: JsonGroup = {
	id: QbUtils.uuid(),
	type: "group"
};

const RuleEdit: React.FC = () => {
	const { t, i18n } = useTranslation();

	const ruleActionOptions: CascaderOption[] = [
		{
			label: t("Action.General"),
			value: 1,
			needExtraParam: false,
			children: [
				{ label: t("Action.Start"), value: "ENABLE" },
				{ label: t("Action.Pause"), value: "DISABLE" },
				// {
				// 	label: t("Action.Close other ads when Incr Complete Payment"),
				// 	value: "custom_close_other_ads"
				// }
			]
		},
		{
			label: t("Action.Budget"),
			value: 2,
			needExtraParam: true,
			children: [
				{ label: t("Action.Increase budget by $"), value: "budget:inc:$" },
				{ label: t("Action.Increase budget by %"), value: "budget:inc:%" },
				{ label: t("Action.Decrease budget by $"), value: "budget:dec:$" },
				{ label: t("Action.Decrease budget by %"), value: "budget:dec:%" },
				{ label: t("Action.Set new budget $"), value: "budget:new:" }
			]
		},
		{
			label: t("Action.Bid(Conversation bid)"),
			value: 3,
			needExtraParam: true,
			children: [
				{ label: t("Action.Increase bid by $"), value: "conversion_bid:inc:$" },
				{ label: t("Action.Increase bid by %"), value: "conversion_bid:inc:%" },
				{ label: t("Action.Decrease bid by $"), value: "conversion_bid:dec:$" },
				{ label: t("Action.Decrease bid by %"), value: "conversion_bid:dec:%" },
				{ label: t("Action.Set new bid $"), value: "conversion_bid:new:" }
			]
		}
		// {
		// 	label: "Bid(CPC and CPM bid)",
		// 	value: 4,
		// 	needExtraParam: true,
		// 	children: [
		// 		{ label: "Increase bid by $", value: "bid:inc:$" },
		// 		{ label: "Increase bid by %", value: "bid:inc:%" },
		// 		{ label: "Decrease bid by $", value: "bid:dec:$" },
		// 		{ label: "Decrease bid by %", value: "bid:dec:%" },
		// 		{ label: "Set new bid $", value: "bid:new:" }
		// 	]
		// }
	];
	/** 由于单独的TS文件 不好做国际化实现
	 * 把fields先添加到Edit中
	 */
	let conatants = {
		most_common: {
		  label: i18n.t("condition.Most common"),
		  type: "!struct",
		  subfields: {
			spent: {
			  label: i18n.t("condition.Spent"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// lifetime_spent: {
			//   label: i18n.t("condition.Lifetime spent"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			frequency: {
			  label: i18n.t("condition.Frequency"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// results: {
			//   label: i18n.t("condition.Results"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			// cost_per_result: {
			//   label: i18n.t("condition.Cost per result"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			mobile_app_install: {
			  label: i18n.t("condition.Mobile app install"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_mobile_app_install: {
			  label: i18n.t("condition.Cost per mobile app install"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_purchase_roas: {
			  label: i18n.t("condition.In-app purchase ROAS"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			website_purchase_roas: {
			  label: i18n.t("condition.Website purchase ROAS"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			}
		  }
		},
		settings: {
		  label: i18n.t("condition.Settings"),
		  type: "!struct",
		  subfields: {
			campaign_name: {
			  label: i18n.t("condition.Campaign name"),
			  type: "text",
			  operators: ['like', 'not_like'],
	  
			},
			
			objective: {
			  label: i18n.t("condition.Objective"),
			  type: "select",
			  operators:['select_equals', 'select_not_equals'],
			  listValues: [
				{ label: "App Engagement", value: "app_engagement" },
				{ label: "App Installs", value: "app_installs" },
				{ label: "Brand Awareness", value: "brand_awareness" },
				{ label: "Catalog Sales", value: "catalog_sales" },
				{ label: "Conversions", value: "conversions" },
				{ label: "Event Responses", value: "event_responses" },
				{ label: "Lead Generation", value: "lead_generation" },
				{ label: "Messages", value: "messages" },
				{ label: "Offer Claims", value: "offer_claims" },
				{ label: "Page Likes", value: "page_likes" },
				{ label: "Post Engagement", value: "post_engagement" },
				{ label: "Reach", value: "reach" },
				{ label: "Store Traffic", value: "store_traffic" },
				{ label: "Traffic", value: "traffic" },
				{ label: "Video Views", value: "video_views" }
			  ]
			},
			buying_type: {
			  label: i18n.t("condition.Buying type"),
			  type: "select",
			  operators: ['select_equals', 'select_not_equals'],
			  listValues: [
				{ label: "Auction", value: "auction" },
				{ label: "Fixed price", value: "fixed_price" },
				{ label: "Reservation", value: "reservation" },
			  ]
			},
			spend_cap: {
			  label: i18n.t("condition.Spend cap"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			}
		  }
		},
		website_conversions: {
		  label: i18n.t("condition.Website Conversions(Meta.Pixel)"),
		  type: "!struct",
		  subfields: {
			all_website_conversions: {
			  label: i18n.t("condition.All Website Conversions(Meta.Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			adds_of_payment_info: {
			  label: i18n.t("condition.Adds of Payment lnfo(Meta.Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			adds_to_cart: {
			  label: i18n.t("condition.Adds to Cart(Meta.Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			adds_to_wishlist: {
			  label: i18n.t("condition.Adds to Wishlist(Meta.Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			registrations_completed: {
			  label: i18n.t("condition.Registrations Completed(Meta.Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			checkouts_initiated: {
			  label: i18n.t("condition.Checkouts Initiated(Meta.Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			leads: {
			  label: i18n.t("condition.Leads (Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			purchases: {
			  label: i18n.t("condition.Purchases(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			searches: {
			  label: i18n.t("condition.Searches (Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			content_views: {
			  label: i18n.t("condition.Content Views(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			other_website_conversions: {
			  label: i18n.t("condition.Other Website Conversions(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			}
		  }
		},
		cost_per_website_conversion: {
		  label: i18n.t("condition.Cost per Website Conversion(Meta Pixel)"),
		  type: "!struct",
		  subfields: {
			cost_per_add_of_payment_info: {
			  label: i18n.t("condition.Cost per Add of Payment lnfo(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_add_to_cart: {
			  label: i18n.t("condition.Cost per Add to Cart(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_add_to_wishlist: {
			  label: i18n.t("condition.Cost per Add to Wishlist(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_registration_completed: {
			  label: i18n.t("condition.Cost per Registration Completed(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_checkout_initiated: {
			  label: i18n.t("condition.Cost per Checkout Initiated(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_lead: {
			  label: i18n.t("condition.Cost per Lead(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_purchase: {
			  label: i18n.t("condition.Cost per Purchase(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_search: {
			  label: i18n.t("condition.Cost per Search(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_content: {
			  label: i18n.t("condition.Cost per Content(Meta Pixel)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			}
		  }
		},
		in_app_events: {
		  label: i18n.t("condition.In-app events"),
		  type: "!struct",
		  subfields: {
			all_in_app_events: {
			  label: i18n.t("condition.All in-app events"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_achievements_unlocked: {
			  label: i18n.t("condition.In-app achievements unlocked"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_sessions: {
			  label: i18n.t("condition.In-app sessions"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_adds_of_payment_info: {
			  label: i18n.t("condition.In-app adds of payment info"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_adds_to_cart: {
			  label: i18n.t("condition.In-app adds to cart"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_adds_to_wishlist: {
			  label: i18n.t("condition.In-app adds to wishlist"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_registrations_completed: {
			  label: i18n.t("condition.In-app registrations completed"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_content_views: {
			  label: i18n.t("condition.In-app content views"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_checkouts_initiated: {
			  label: i18n.t("condition.In-app checkouts initiated"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_levels_completed: {
			  label: i18n.t("condition.In-app levels completed"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_purchases: {
			  label: i18n.t("condition.In-app purchases"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_ratings_submitted: {
			  label: i18n.t("condition.In-app ratings submitted"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_searches: {
			  label: i18n.t("condition.In-app searches"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_credits_spent: {
			  label: i18n.t("condition.In-app credits spent"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			in_app_tutorials_completed: {
			  label: i18n.t("condition.In-app tutorials completed"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			other_in_app_actions: {
			  label: i18n.t("condition.Other in-app actions"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			}
		  }
		},
		cost_per_in_app_event: {
		  label: i18n.t("condition.Cost per in-app event"),
		  type: "!struct",
		  subfields: {
			cost_per_in_app_achievement_unlocked: {
			  label: i18n.t("condition.Cost per in-app achievement unlocked"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_session: {
			  label: i18n.t("condition.Cost per in-app session"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_add_of_payment_info: {
			  label: i18n.t("condition.Cost per in-app add of payment info"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_add_to_cart: {
			  label: i18n.t("condition.Cost per in-app add to cart"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_add_to_wishlist: {
			  label: i18n.t("condition.Cost per in-app add to wishlist"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_registration_completed: {
			  label: i18n.t("condition.Cost per in-app registration completed"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_content_view: {
			  label: i18n.t("condition.Cost per in-app content view"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_checkout_initiated: {
			  label: i18n.t("condition.Cost per in-app checkout initiated"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_level_completed: {
			  label: i18n.t("condition.Cost per in-app level completed"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_purchase: {
			  label: i18n.t("condition.Cost per in-app purchase"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_rating_submitted: {
			  label: i18n.t("condition.Cost per in-app rating submitted"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_search: {
			  label: i18n.t("condition.Cost per in-app search"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_credit_spent: {
			  label: i18n.t("condition.Cost per in-app credit spent"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_in_app_tutorial_completed: {
			  label: i18n.t("condition.Cost per in-app tutorial completed"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			}
		  }
		},
		// offline_conversions: {
		//   label: i18n.t("condition.Offline conversions"),
		//   type: "!struct",
		//   subfields: {
		// 	all_offline_conversions: {
		// 	  label: i18n.t("condition.All offline conversions"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_adds_of_payment_info: {
		// 	  label: i18n.t("condition.Offline adds of payment info"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_adds_to_cart: {
		// 	  label: i18n.t("condition.Offline adds to cart"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_adds_to_wishlist: {
		// 	  label: i18n.t("condition.Offline adds to wishlist"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_registrations_completed: {
		// 	  label: i18n.t("condition.Offline Registrations Completed"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_checkouts_initiated: {
		// 	  label: i18n.t("condition.Offline checkouts Initiated"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_leads: {
		// 	  label: i18n.t("condition.Offline leads"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	other_offline_conversions: {
		// 	  label: i18n.t("condition.Other offline conversions"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_purchases: {
		// 	  label: i18n.t("condition.Offline purchases"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_searches: {
		// 	  label: i18n.t("condition.Offline searches"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	offline_content_views: {
		// 	  label: i18n.t("condition.Offline content views"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	}
		//   }
		// },
		// cost_per_offline_conversion: {
		//   label: i18n.t("condition.Cost per offline conversion"),
		//   type: "!struct",
		//   subfields: {
		// 	cost_per_offline_conversion: {
		// 		label: i18n.t("condition.Cost per offline conversion"),
		// 		type: "number",
		// 		operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	  },
		// 	cost_per_offline_add_of_payment_info: {
		// 	  label: i18n.t("condition.Cost per offline add of payment info"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	cost_per_offline_add_to_cart: {
		// 	  label: i18n.t("condition.Cost per offline add to cart"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	cost_per_offline_registration_completed: {
		// 	  label: i18n.t("condition.Cost per offline registration completed"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	cost_per_offline_checkout_initiated: {
		// 	  label: i18n.t("condition.Cost per offline checkout initiated"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	cost_per_offline_lead: {
		// 	  label: i18n.t("condition.Cost per offline lead"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	cost_per_other_offline_conversion: {
		// 	  label: i18n.t("condition.Cost per other offline conversion"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	cost_per_offline_purchase: {
		// 	  label: i18n.t("condition.Cost per offline purchase"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	},
		// 	cost_per_offline_content_view: {
		// 	  label: i18n.t("condition.Cost per offline content view"),
		// 	  type: "number",
		// 	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
		// 	}
		//   }
		// },
		other: {
		  label: i18n.t("condition.Other"),
		  type: "!struct",
		  subfields: {
			cpc_link: {
			  label: i18n.t("condition.CPC (Link)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			link_clicks: {
			  label: i18n.t("condition.Link clicks"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cpm: {
			  label: i18n.t("condition.CPM"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			ctr_link: {
			  label: i18n.t("condition.CTR (Link)"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// lifetime_impressions: {
			//   label: i18n.t("condition.Lifetime impressions"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			impressions: {
			  label: i18n.t("condition.Impressions"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			reach: {
			  label: i18n.t("condition.Reach"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			leads: {
			  label: i18n.t("condition.Leads"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// actions: {
			//   label: i18n.t("condition.Actions"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			clicks: {
			  label: i18n.t("condition.Clicks"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// cpa: {
			//   label: i18n.t("condition.CPA"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			cpc: {
			  label: i18n.t("condition.CPC"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cpp: {
			  label: i18n.t("condition.CPP"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			ctr: {
			  label: i18n.t("condition.CTR"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// result_rate: {
			//   label: i18n.t("condition.Result rate"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			cost_per_unique_click: {
			  label: i18n.t("condition.Cost per unique click"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			unique_clicks: {
			  label: i18n.t("condition.Unique clicks"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// today_spent: {
			//   label: i18n.t("condition.Today spent"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			// yesterday_spent: {
			//   label: i18n.t("condition.Yesterday spent"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			post_engagement: {
			  label: i18n.t("condition.Post engagement"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_post_engagement: {
			  label: i18n.t("condition.Cost per post engagement"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			three_second_video_views: {
			  label: i18n.t("condition.3-Second video views"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			cost_per_video_view: {
			  label: i18n.t("condition.Cost per video vlew"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			page_likes: {
			  label: i18n.t("condition.Page likes"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// offsite_engagements: {
			//   label: i18n.t("condition.Offsite engagements"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			posts: {
			  label: i18n.t("condition.Posts"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			post_comments: {
			  label: i18n.t("condition.Post comments"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			post_reactions: {
			  label: i18n.t("condition.Post reactions"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			content_views: {
			  label: i18n.t("condition.Content views"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			clicks_to_play_video: {
			  label: i18n.t("condition.Clicks to play video"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			// question_answers: {
			//   label: i18n.t("condition.Question answers"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			// messaging_replies: {
			//   label: i18n.t("condition.Messaging replies"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			// cost_per_messaging_reply: {
			//   label: i18n.t("condition.Cost per messaging reply"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			// new_messaging_connections: {
			//   label: i18n.t("condition.New messaging connections"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
			// cost_per_new_messaging_connection: {
			//   label: i18n.t("condition.Cost per new messaging connection"),
			//   type: "number",
			//   operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			// },
		  }
		}
	  };



	   const CampaignFields_Settings = {

		label: i18n.t("condition.Settings"),
		type: "!struct",
		subfields: {
			campaign_name: {
			  label: i18n.t("condition.Campaign name"),
			  type: "text",
			  operators: ['like', 'not_like'],
			},
			objective: {
			  label: i18n.t("condition.Objective"),
			  type: "select",
			  operators:['select_equals', 'select_not_equals'],
			  listValues: [
				{ title: i18n.t("condition.App Engagement"), value: "app_engagement" },
				{ title: i18n.t("condition.App Installs"), value: "app_installs" },
				{ title: i18n.t("condition.Brand Awareness"), value: "brand_awareness" },
				{ title: i18n.t("condition.Catalog Sales"), value: "catalog_sales" },
				{ title: i18n.t("condition.Conversions"), value: "conversions" },
				{ title: i18n.t("condition.Event Responses"), value: "event_responses" },
				{ title: i18n.t("condition.Lead Generation"), value: "lead_generation" },
				{ title: i18n.t("condition.Messages"), value: "messages" },
				{ title: i18n.t("condition.Offer Claims"), value: "offer_claims" },
				{ title: i18n.t("condition.Page Likes"), value: "page_likes" },
				{ title: i18n.t("condition.Post Engagement"), value: "post_engagement" },
				{ title: i18n.t("condition.Reach"), value: "reach" },
				{ title: i18n.t("condition.Store Traffic"), value: "store_traffic" },
				{ title: i18n.t("condition.Traffic"), value: "traffic" },
				{ title: i18n.t("condition.Video Views"), value: "video_views" }
			  ]
			},
			buying_type: {
			  label: i18n.t("condition.Buying type"),
			  type: "select",
			  operators: ['select_equals', 'select_not_equals'],
			  listValues: [
				{ title: "Auction", value: "auction" },
				{ title: "Fixed price", value: "fixed_price" },
				{ title: "Reservation", value: "reservation" },
			  ]
			},
			spend_cap: {
			  label: i18n.t("condition.Spend cap"),
			  type: "number",
			  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			}
		  }
	};
 const AdGroupFields_Settings = {
	label: i18n.t("condition.Settings"),
	type: "!struct",
	subfields: {
	  campaign_name: {
		label: i18n.t("condition.Campaign name"),
		type: "text",
		operators: ['like', 'not_like'],
	  },
	  ad_set_name: {
		label: i18n.t("condition.Ad set name"),
		type: "text",
		operators: ["like", "not_like"]
	  },
	  placement: {
		label: i18n.t("condition.Placement"),
		type: "select",
		operators: ["select_any_in","select_not_any_in","select_contains_all"],
		listValues: [
		  { title: i18n.t("condition.Facebook feeds(desktop)"), value: "facebook_feeds_desktop" },
		  { title: i18n.t("condition.Facebook feeds (mobile)"), value: "facebook_feeds_mobile" },
		  { title: i18n.t("condition.Facebook right column"), value: "facebook_right_column" },
		  { title: i18n.t("condition.Instagram feed"), value: "instagram_feed" },
		  { title: i18n.t("condition.Instagram Stories"), value: "instagram_stories" },
		  { title: i18n.t("condition.Audience Network"), value: "audience_network" },
		  { title: i18n.t("condition.Messenger inbox"), value: "messenger_inbox" },
		  { title: i18n.t("condition.Facebook Marketplace"), value: "facebook_marketplace" }
		]
	  },
	  lifetime_budget: {
		label: i18n.t("condition.Lifetime budget"),
		type: "number",
		operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
	  },
	  daily_budget: {
		label: i18n.t("condition.Daily budget"),
		type: "number",
		operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
	  },
	  bid_amount: {
		label: i18n.t("condition.Bid amount"),
		type: "number",
		operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
	  },
	  billing_event: {
		label: i18n.t("condition.Billing event"),
		type: "select",
		operators: ['select_equals', 'select_not_equals'],
		listValues: [
		  { title: i18n.t("condition.Impressions"), value: "IMPRESSIONS" },
		  { title: i18n.t("condition.App Installs"), value: "APP_INSTALLS" },
		  { title: i18n.t("condition.Clicks"), value: "CLICK" },
		  { title: i18n.t("condition.Link clicks"), value: "LINK_CLICK" },
		  { title: i18n.t("condition.Offer claims"), value: "OFFER_CLAIM" },
		  { title: i18n.t("condition.Page likes"), value: "PAGE_LIKE" },
		  { title: i18n.t("condition.Post Engagement"), value: "POST_ENGAGEMENT" },
		  { title: i18n.t("condition.10-second video views"), value: "10-SECOND_VIDEO_VIEW" }
		]
	  },
	  optimization_goal: {
		label: i18n.t("condition.Optimization goal"),
		type: "select",
		operators: ['select_equals', 'select_not_equals'],
		listValues: [
		  { title: i18n.t("condition.App Installs"), value: "APP_INSTALLS" },
		  { title: i18n.t("condition.Brand awareness"), value: "BRAND_AWARENESS" },
		  { title: i18n.t("condition.Clicks on your ad"), value: "CLICKS_ON_YOUR_AD" },
		  { title: i18n.t("condition.Engaged users"), value: "ENGAGED_USERS" },
		  { title: i18n.t("condition.FBX usage"), value: "FBX_USAGE" },
		  { title: i18n.t("condition.Event response"), value: "EVENT_RESPONSE" },
		  { title: i18n.t("condition.Impressions"), value: "IMPRESSIONS" },
		  { title: i18n.t("condition.Leads"), value: "LEADS" },
		  { title: i18n.t("condition.Link clicks"), value: "LINK_CLICKS" },
		  { title: i18n.t("condition.Offer claims"), value: "OFFER_CLAIMS" },
		  { title: i18n.t("condition.Conversions"), value: "CONVERSIONS" },
		  { title: i18n.t("condition.Page engagement"), value: "PAGE_ENGAGEMENT" },
		  { title: i18n.t("condition.Page Likes"), value: "PAGE_LIKES" },
		  { title: i18n.t("condition.Post Engagement"), value: "POST_ENGAGEMENT" },
		  { title: i18n.t("condition.Daily unique reach"), value: "DAILY_UNIQUE_REACH" },
		  { title: i18n.t("condition.Replies"), value: "REPLIES" },
		  { title: i18n.t("condition.Social impressions"), value: "SOCIAL_IMPRESSIONS" },
		  { title: i18n.t("condition.10-second video views"), value: "10-SECOND_VIDEO_VIEWS" }
		]
	  }
	}
  };
  
  
   const AdFields_Settings = {
   
	  label: i18n.t("condition.Settings"),
	  type: "!struct",
	  subfields: {
	campaign_name: {
	  label: i18n.t("condition.Campaign name"),
	  type: "text",
	  operators: ["like", "not_like"]
	},
	ad_set_name: {
	  label: i18n.t("condition.Ad set name"),
	  type: "text",
	  operators: ["like", "not_like"]
	},
	ad_name: {
	  label: i18n.t("condition.Ad name"),
	  type: "text",
	  operators: ["like", "not_like"]
	},
	bid_amount: {
	  label: i18n.t("condition.Bid amount"),
	  type: "number",
	  operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
	}
  }
  };
  

	const isShare = getQueryVariable("share") !== undefined;
	// 复制
	const isDup = getQueryVariable("dup") === "1";
	// 旧版本rule_id入参

	const rid = getQueryVariable("rid");
	const type = getQueryVariable("type");

	const auto_cpa = getQueryVariable("auto_cpa");
	const shareCode = getQueryVariable("share");

	const { currentUser, language } = useSelector(state => state.global);

	const params = useParams<RouterParams>();

	const [form] = ProForm.useForm();

	const navigator = useNavigate();
	let id = getQueryVariable("id");
	if (id === undefined) {
		// 旧版本分享链接的兼容, 旧版本使用rid传参
		id = rid;
	}

	const defaultQueryBuilderConfig: Config = {
		...queryBuilderInitialConfig,
		settings: {
			...queryBuilderInitialConfig.settings,
			removeIncompleteRulesOnLoad: false,
			showNot: false,
			valueSourcesInfo: {}
		},
		fields: conatants
	};

	const [spinning, setSpinning] = useState(id !== undefined);
	const [initValue, setInitValue] = useState<InitValue>({
		enable_time_range: ["00:00:00", "23:59:59"],
		reportPeriod: "TODAY"
	});

	const [advOptions, setAdvOptions] = useState<DefaultOptionType[]>([]);

	const [queryBuilderTree, setQueryBuilderTree] = useState(QbUtils.loadTree(defaultQueryBuilderValue));
	const [queryBuilderConfig, setQueryBuilderConfig] = useState(defaultQueryBuilderConfig);

	const [actionParamInputDisplay, setActionParamInputDisplay] = useState(false);
	const [ruleActionValue, setRuleActionValue] = useState<any[]>([]);
	const [ruleActionParamValue, setRuleActionParamValue] = useState<number>();

	const [RuleActionConfig, setRuleActionConfig] = useState(ruleActionOptions);

	const [languageLoading, setLangugaeLoading] = useState(false);

	const [needBudgetUpperLimit, setNeedBudgetUpperLimit] = useState(false);

	let initRule =
		'{"left":{},"children":[{"op":"equal","left":{"type":"field","field":"spent"},"right":100}],"conjunction":"and"}';

	useEffect(() => {
		// 初始化广告账户列表
		fetchADAccountList({
			isActive: 1,
			pageSize: 999
		}).then(res => {
			const data = res.data?.list;
			if (!data || data?.length === 0) {
				return;
			}

			let list = data.map(item => {
				return {
					advId: item.advId,
					advName: item.advName,
					tiktokUserId: item.tiktokUserId
				};
			});

			setAdvOptions(list);
			/** 默认初始化一行数据 */
		});

		if (!id) {
			/** 初始状态没有规则时，
			 * 设置空状态，展示添加规则的页面
			 */
			setQueryBuilderTree(loadFromTreeForGo(JSON.parse(initRule),conatants));

			return;
		}

		const ruleItemParams: { auto_cpa?: number } = {};
		if (auto_cpa) {
			ruleItemParams.auto_cpa = Number(auto_cpa);
		}

		// 初始化已有的规则信息
		fetchStrategyDetail(Number(id), shareCode).then(res => {
			const data = res.data;
			if (!data) {
				return;
			}
			scopeChange(data.scope, "backfill", data);
			// setStrategy(data)

			const ruleValue: InitValue = {
				strategy_name: data.strategyName,
				enable_time_range: [data.enableTimeStart, data.enableTimeEnd],
				scope: data.scope,
				scope_status: data.scopeStatus,
				is_repetitive: data.isRepetitive,
				frequency: currentUser?.currentPlan?.ruleFrequency,
				reportPeriod: data.reportPeriod
			};

			if (!isShare) {
				ruleValue.advIds = data.bindAdvList.map(item => item.advId);
			}
			if (isDup) {
				ruleValue.strategy_name += " copy";
			}
			if (isShare) {
				ruleValue.strategy_name += " share";
			}

			setInitValue(ruleValue);

			const ruleActionGroup = ruleActionOptions.find(
				item => item.children && item.children.some(childrenItem => childrenItem.value === data.action)
			);
			/** 添加规则动作 */
			if (ruleActionGroup) {
				setRuleActionValue([ruleActionGroup.value, data.action]);
				if (ruleActionGroup.needExtraParam) {
					setActionParamInputDisplay(true);

					setRuleActionParamValue(JSON.parse(data.actionValue));
				}
			}

			// setQueryBuilderTree(loadFromTreeForGo(JSON.parse(data.strategyCondition)));
			setSpinning(false);
		});
	}, []);

	const handleAdd = async (params: ADR.EditRuleParams) => {
		const res = await fetchCreateStrategy(params);
		// message.success(intl.formatMessage(''));
		if (res.code === 200) {
			message.success("操作完成");
			navigator("/Automated/manage");
		}
	};

	const handleEdit = async (id: number, params: ADR.EditRuleParams) => {
		const res = await fetchEditRules({
			strategyId: id,
			...params
		});
		if (res.code === 200) {
			message.success("操作完成");
			navigator("/Automated/manage");
		}
	};
	const onQueryBuilderChange = (immutableTree: ImmutableTree, cfg: Config) => {
		setQueryBuilderTree(immutableTree);
		setQueryBuilderConfig(cfg);
		console.log("immutableTree",immutableTree)
		console.log("convertTreeForGo(queryBuilderTree)",convertTreeForGo(immutableTree))
		// console.log("loadFromTreeForGo(JSON.parse(initRule),conatants)",loadFromTreeForGo(JSON.parse(initRule),conatants))
	};

	const queryBuilderRenderBuilder = (props: BuilderProps) => (
		<div className="query-builder-container" style={{ padding: "10px" }}>
			<div className="query-builder qb-lite">
				<Builder {...props} />
			</div>
		</div>
	);



	const onFinish = async () => {

		await form.validateFields();

		const values = form.getFieldsValue();

		console.log("	提交时的	values",values)
		console.log("提交时的ruleActionParamValue",ruleActionParamValue)
		if (!ruleActionValue || !ruleActionValue?.length) {
			return;
		}

		let advIds = values.advIds.map(item => {
			item.advId;
			if (typeof item === "string") {
				return item;
			} else {
				return item.advId;
			}
		});
		const params: ADR.EditRuleParams = {
			strategyName: values.strategyName,
			action: ruleActionValue[1],
			scope: values.scope,
			scopeStatus: values.scopeStatus,
			strategyCondition: JSON.stringify(convertTreeForGo(queryBuilderTree)),
			// strategyCondition: convertTreeForGo(queryBuilderTree),

			advIds: advIds,
			enableTimeStart: values.enableTimeRange[0].format("HH:mm:ss"),
			enableTimeEnd: values.enableTimeRange[1].format("HH:mm:ss"),
			isRepetitive: values.isPepetitive,
			frequency: currentUser?.currentPlan?.ruleFrequency || 5,
			reportPeriod: values.reportPeriod
		};

		if (ruleActionParamValue) {
			params.actionValue = JSON.stringify(ruleActionParamValue);
		}

		/** 禁止提交规则组下只有单个条件的规则 */
		const buildTrees = convertTreeForGo(queryBuilderTree).children;

		let flag = false;
		let flagField = false
		const deppFindChild = (item): boolean => {
			if (!item.children) {
				return true;
			}
			if (item.children.length === 1) {
				flag = true;
				return false;
			}

			for (let i = 0; i < item.children.length; i++) {
				deppFindChild(item.children[i]);
			}
		};
		const deppFindChildField = (item): boolean => {
		
			if (!item.children) {
				if (!item?.left?.field && !item?.conjunction) {
					flagField = true;
					return true;
				}
				if ((item.right === undefined || item.right === null) && !item?.children) {
					flagField = true;
					return true;
				}
				if (!item?.op) {
					flagField = true;
					return true;
				}
				return true;
			} else {
				for (let i = 0; i < item.children?.length; i++) {
					deppFindChild(item.children[i]);
				}
			}
		
		};
		if (buildTrees.length > 0) {
			buildTrees.forEach(item => {
				if (item.children) {
					deppFindChild(item);
				}
				deppFindChildField(item)
			});
			if (flag) {
				message.info("禁止创建策略组中只包含单个条件的规则");
				return;
			}
			if(flagField){
				message.info("禁止创建策略条件为空的规则");
return
			}
		}
		/** 禁止提交规则组下只有单个条件的规则 */

		if (id && !isShare && !isDup && type !== "useMarket") {
			await handleEdit(Number(id), params);
		} else {
			await handleAdd(params);
		}

		setRuleActionParamValue({});
		form.resetFields();
	};

	

	const scopeChange = (value, type, data) => {
		let newfields;
		/** 生效维度变化时，判断规则中是否涉及维度，如涉及则清空，若不涉及，则保持原来规则 */
		if (value === "campaign") {
			setQueryBuilderConfig({
				...queryBuilderInitialConfig,
				settings: {
					...queryBuilderInitialConfig.settings,
					showNot: false,
					removeIncompleteRulesOnLoad: false,
					valueSourcesInfo: {}
				},
				fields: {
					
					...conatants,
					settings: {
						
						...CampaignFields_Settings
					}
				}
			});

			newfields = {
				campaign_name: {
					label: t("condition.Campaign name"),
					type: "text",
					operators: ["like", "not_like"]
				},
				...conatants,
				settings: {
					
					...CampaignFields_Settings
				}
			};
			setRuleActionConfig([
				{
					label: t("Action.General"),
					value: 1,
					needExtraParam: false,
					children: [
						{ label: t("Action.Start"), value: "ENABLE" },
						{ label: t("Action.Pause"), value: "DISABLE" },
						// {
						// 	label: t("Action.Close other ads when Incr Complete Payment"),
						// 	value: "custom_close_other_ads"
						// }
					]
				},
				{
					label: t("Action.Budget"),
					value: 2,
					needExtraParam: true,
					children: [
						{ label: t("Action.Increase budget by $"), value: "budget:inc:$" },
						{ label: t("Action.Increase budget by %"), value: "budget:inc:%" },
						{ label: t("Action.Decrease budget by $"), value: "budget:dec:$" },
						{ label: t("Action.Decrease budget by %"), value: "budget:dec:%" },
						{ label: t("Action.Set new budget $"), value: "budget:new:" }
					]
				}
			]);
		}
		if (value === "adgroup") {
			setQueryBuilderConfig({
				...queryBuilderInitialConfig,
				
				settings: {
					...queryBuilderInitialConfig.settings,
					showNot: false,
					removeIncompleteRulesOnLoad: false,
					valueSourcesInfo: {}
				},
				fields: {
				
					...conatants,
				
					// settings: {
						
					// 	...AdGroupFields_Settings
					// }
				}
			});

			newfields = {
				adgroup_name: {
					label: t("condition.Adgroup name"),
					type: "text",
					operators: ["like", "not_like"]
				},
				...conatants,
				most_common: {
					...conatants.most_common,
					
					subfields:{
						...conatants.most_common.subfields,
					// ...AdgroupMostCommon
					}
				},
				settings: {
					
					...AdGroupFields_Settings
				}
			};

			setRuleActionConfig(ruleActionOptions);
		}
		if (value === "ad") {
			setQueryBuilderConfig({
				...queryBuilderInitialConfig,
				settings: {
					...queryBuilderInitialConfig.settings,
					showNot: false,
					removeIncompleteRulesOnLoad: false,
					valueSourcesInfo: {}
				},
				fields: {
					
					...conatants,
					settings: {
						
						...AdFields_Settings
					}
				}
			});

			newfields = {
				ad_name: {
					label: t("condition.Ad name"),
					type: "text",
					operators: ["like", "not_like"]
				},
				...conatants,
				settings: {
					
					...AdFields_Settings
				}
			};

			setRuleActionConfig([
				{
					label: t("Action.General"),
					value: 1,
					needExtraParam: false,
					children: [
						{ label: t("Action.Start"), value: "ENABLE" },
						{ label: t("Action.Pause"), value: "DISABLE" },
						// {
						// 	label: t("Action.Close other ads when Incr Complete Payment"),
						// 	value: "custom_close_other_ads"
						// }
					]
				}
			]);
		}
		if (type === "backfill") {
			form.setFieldValue("querytree", loadFromTreeForGo(JSON.parse(data.strategyCondition), newfields));
			form.setFieldsValue(ruleActionParamValue)
			setQueryBuilderTree(loadFromTreeForGo(JSON.parse(data.strategyCondition), newfields));
		}


		setRuleActionParamValue({})
		setRuleActionValue([])
	};

	if (languageLoading) {
		return <Spin />;
	}

	const handleChangeScope = value => {
		console.log("value>>>>>>",value)
		let newFileds;
		if (value === "campaign") {
			newFileds = {
			
				...conatants,
				settings: {
					
					...CampaignFields_Settings
				}
			
			};
		}
		if (value === "adgroup") {
			newFileds = {
			
				...conatants,
				most_common: {
					...conatants.most_common,
					subfields:{
						...conatants.most_common.subfields,
					// ...AdgroupMostCommon
					}
				},
				settings: {
					
					...AdGroupFields_Settings
				}
			};
		}
		if (value === "ad") {
			newFileds = {
			
				...conatants,
				settings: {
					
					...AdFields_Settings
				}
			
			
			};
		}

		if (!value) {
			return conatants;
		}

		console.log("newFileds>>>>>>",newFileds)
		return newFileds;
	};

	const handleChangeActionScope = value => {
		if (value === "campaign") {
			return [
				{
					label: t("Action.General"),
					value: 1,
					needExtraParam: false,
					children: [
						{ label: t("Action.Start"), value: "ENABLE" },
						{ label: t("Action.Pause"), value: "DISABLE" },
						// {
						// 	label: t("Action.Close other ads when Incr Complete Payment"),
						// 	value: "custom_close_other_ads"
						// }
					]
				},
				{
					label: t("Action.Budget"),
					value: 2,
					needExtraParam: true,
					children: [
						{ label: t("Action.Increase budget by $"), value: "budget:inc:$" },
						{ label: t("Action.Increase budget by %"), value: "budget:inc:%" },
						{ label: t("Action.Decrease budget by $"), value: "budget:dec:$" },
						{ label: t("Action.Decrease budget by %"), value: "budget:dec:%" },
						{ label: t("Action.Set new budget $"), value: "budget:new:" }
					]
				}
			];
		}
		if (value === "adgroup") {
			return [
				{
					label: t("Action.General"),
					value: 1,
					needExtraParam: false,
					children: [
						{ label: t("Action.Start"), value: "ENABLE" },
						{ label: t("Action.Pause"), value: "DISABLE" },
						// {
						// 	label: t("Action.Close other ads when Incr Complete Payment"),
						// 	value: "custom_close_other_ads"
						// }
					]
				},
				{
					label: t("Action.Budget"),
					value: 2,
					needExtraParam: true,
					children: [
						{ label: t("Action.Increase budget by $"), value: "budget:inc:$" },
						{ label: t("Action.Increase budget by %"), value: "budget:inc:%" },
						{ label: t("Action.Decrease budget by $"), value: "budget:dec:$" },
						{ label: t("Action.Decrease budget by %"), value: "budget:dec:%" },
						{ label: t("Action.Set new budget $"), value: "budget:new:" },
						{ label: t("Action.Scale budget by target field"), value: "budget:target:" }
					]
				},
				// {
				// 	label: t("Action.Bid(Conversation bid)"),
				// 	value: 3,
				// 	needExtraParam: true,
				// 	children: [
				// 		{ label: t("Action.Increase bid by $"), value: "conversion_bid:inc:$" },
				// 		{ label: t("Action.Increase bid by %"), value: "conversion_bid:inc:%" },
				// 		{ label: t("Action.Decrease bid by $"), value: "conversion_bid:dec:$" },
				// 		{ label: t("Action.Decrease bid by %"), value: "conversion_bid:dec:%" },
				// 		{ label: t("Action.Set new bid $"), value: "conversion_bid:new:" }
				// 	]
				// }
				{
					label: t("手动竞价"),
					value: 3,
					needExtraParam: true,
					children: [
						{ label: t("Action.Increase bid by $"), value: "conversion_bid:inc:$" },
						// { label: t("Action.Increase bid by %"), value: "conversion_bid:inc:%" },
						{ label: t("Action.Decrease bid by $"), value: "conversion_bid:dec:$" },
						// { label: t("Action.Decrease bid by %"), value: "conversion_bid:dec:%" },
						{ label: t("根据目标调整竞价"), value: "conversion_bid:new:" }
					]
				}
			];
		}
		if (value === "ad") {
			return [
				{
					label: t("Action.General"),
					value: 1,
					needExtraParam: false,
					children: [
						{ label: t("Action.Start"), value: "ENABLE" },
						{ label: t("Action.Pause"), value: "DISABLE" },
						// {
						// 	label: t("Action.Close other ads when Incr Complete Payment"),
						// 	value: "custom_close_other_ads"
						// }
					]
				}
			];
		}
	};

	const renderBudget = () => {

		if(!ruleActionValue || !ruleActionValue.length){
			return null
		}
		if (ruleActionValue[1] === "budget:new:") {
			return (
				<div className="budget-input">
					<ProFormText
						label={t("预算值")}
						name="value"
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
					    
						min={0.01}
						// value={ruleActionParamValue?.value}
						onChange={({target:{value}}) => {
							setRuleActionParamValue({...ruleActionParamValue, value:value})}
						}
						rules={[{ required: true, message: t("请输入预算值") }]}
						fieldProps={{
							value:ruleActionParamValue?.value,
							addonAfter: "USD"
						}}
					/>
				</div>
			);
		}
		if (ruleActionValue[1] === "budget:inc:$" || ruleActionValue[1] === "budget:inc:%") {
			return (
				<div className="budget-input">
					<ProFormText
						label={t("预算值")}
						name="value"
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
					
						
						// value={ruleActionParamValue?.value}
						onChange={({target:{value}}) => {
							setRuleActionParamValue({...ruleActionParamValue, value:value})}
						}
						rules={[{ required: true, message: t("请输入数值") }]}
						fieldProps={{
							value:ruleActionParamValue?.value,
							addonAfter: ruleActionValue[1] === "budget:inc:$" ? "USD" : "%"
						}}
					/>
					<ProFormText
						label={t("预算上限")}
						name="max"
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
					
						value={ruleActionParamValue?.max}
						onChange={({target:{value}}) => {
							
							setRuleActionParamValue({...ruleActionParamValue, max:value})}
						}
						rules={[{ required: true, message: t("请输入预算上限值") }]}
						fieldProps={{
							addonAfter: "USD"
						}}
					/>
				</div>
			);
		}
		if (ruleActionValue[1] === "budget:dec:%" || ruleActionValue[1] === "budget:dec:$") {
			return (
				<div className="budget-input">
					<ProFormText
						label={t("预算值")}
						name="value"
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
						precision={2}
						min={0.01}
						// value={ruleActionParamValue?.value}
						onChange={({target:{value}}) => {
							setRuleActionParamValue({...ruleActionParamValue, value:value})}
						}
						rules={[{ required: true, message: t("请输入数值") }]}
						fieldProps={{
							addonAfter: ruleActionValue[1] === "budget:dec:$" ? "USD" : "%"
						}}
					/>
					<ProFormText
						label={t("预算下限")}
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
						name="min"
						value={ruleActionParamValue?.min}
						onChange={({target:{value}}) => {
							setRuleActionParamValue({...ruleActionParamValue, min:value})}
						}
						rules={[{ required: true, message: t("请输入预算下限值") }]}
						fieldProps={{
							value:ruleActionParamValue?.min,
							addonAfter: "USD" 
						}}
					/>
				</div>
			);
		}
		if (ruleActionValue[1] === "budget:target:") {
			form.setFieldsValue({max:999999})
			return (
				<div >
					<div className="budget-input">
						<ProFormSelect
							label={t("调整目标")}
							name="target"
							options={[
								{ label: "广告花费回报 (ROAS)-移动应用购物", value: "ROAS_MOBILE_APP_SHOPPING" },
								{ label: "广告花费回报 (ROAS)-网站购物", value: "ROAS_WEBSITE_SHOPPING" },
								{ label: "单次移动应用安装费用", value: "COST_PER_MOBILE_APP_INSTALL" },
								{ label: "单次移动应用购物费用", value: "COST_PER_MOBILE_APP_SHOPPING" },
								{ label: "单次购物费用(Meta Pixel 像素代码)", value: "COST_PER_SHOPPING_META_PIXEL" },
								{ label: "单次线下购物费用", value: "COST_PER_OFFLINE_SHOPPING" },
								{ label: "单次成效费用", value: "COST_PER_CONVERSION" },
								{ label: "千次展示费用", value: "COST_PER_THOUSAND_IMPRESSIONS" },
								{ label: "CPA", value: "CPA" },
								{ label: "CPC", value: "CPC" }
							]}
							placeholder={t("请选择调整目标")}
							style={{ width: "100%",  }}
							value={ruleActionParamValue?.target}
							onChange={value => setRuleActionParamValue({...ruleActionParamValue, target:value})}
							rules={[{ required: true, message: t("请选择调整目标") }]}
						/>
						<ProFormText
							label={t("目标值")}
							name="value"
							// placeholder={t("automatedRules.editStrategy.action.message")}
							placeholder={t("请输入目标值")}
							style={{ width: "100%", }}
							precision={2}
							min={0.01}
							value={ruleActionParamValue?.value}
							onChange={({target:{value}}) => {
								setRuleActionParamValue({...ruleActionParamValue, value:value})}
							}
							fieldProps={{
								addonAfter: "USD"
							}}
							rules={[{ required: true, message: t("请输入目标值") }]}
						/>
					</div>
					<div>
						<ProFormItem label={t("预算范围")} rules={[{ required: true, message: t("请输入预算范围") }]} name="budgetRange">
						<Space direction="horizontal" size={16} >
						
							<ProFormText
								name={"min"}
								placeholder={t("请输入最小值")}
								rules={[{ required: true,min:0, message: t("请输入最小值") }]}
								fieldProps={{
									addonAfter: "USD",
									onChange: (e) => {
										const minValue = parseFloat(e.target.value);
										const maxValue = form.getFieldValue('max');
										
										if (minValue < maxValue) {
											setRuleActionParamValue({...ruleActionParamValue, min:maxValue})
											form.setFieldsValue({budgetRange:minValue+":"+maxValue})
										}
										if(!minValue){
											form.setFieldsValue({ budgetRange:null});
										}
										
									},
									style: { width: "100%", marginTop: "10px", marginBottom: "0px" }
								}}
							/>
							<span style={{borderBottom:"2px solid #999",display:"inline-block",width:"12px",paddingBottom:"10px",marginBottom:'20px'}}></span>
							<ProFormText
							
								name="max"
								// placeholder={t("automatedRules.editStrategy.action.message")}
								placeholder={t("请输入最大值")}
								fieldProps={{
									addonAfter: "USD",
								    defaultValue:999999,

									onChange: (e) => {
										const maxValue = parseFloat(e.target.value);
										const minValue = form.getFieldValue('min');
										if (maxValue < minValue) {
											setRuleActionParamValue({...ruleActionParamValue, max:minValue})
											form.setFieldsValue({ budgetRange: minValue + ":" + maxValue });
										}
										if(!maxValue){
											form.setFieldsValue({ budgetRange:null});
										}
									}	,
									style: { width: "100%", marginTop: "10px", marginBottom: "0px" }

								}}
								rules={[{ required: true,min:0, message: t("请输入最大值") }]}

							
							/>
						</Space>
						</ProFormItem>
					</div>
				</div>
			);
		}

		/** 手动竞价 */
		if (ruleActionValue[1] === "conversion_bid:inc:$" || ruleActionValue[1] === "conversion_bid:inc:$") {
			return (
				<div className="budget-input">
					<ProFormText
						label={t("竞价值")}
						name="value"
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
						precision={2}
						min={0.01}
						value={ruleActionParamValue?.value}
						onChange={({target:{value}}) => {
							setRuleActionParamValue({...ruleActionParamValue, value:value})}
						}
						rules={[{ required: true, message: t("请输入数值") }]}
						fieldProps={{
							addonAfter: "USD"
						}}
					/>
						<ProFormText
						label={t("竞价上限值")}
						name="max"
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
						precision={2}
						min={0.01}
						value={ruleActionParamValue?.max}
						onChange={({target:{value}}) => {
							setRuleActionParamValue({...ruleActionParamValue, max:value})}
						}
						rules={[{ required: true, message: t("请输入竞价上限值") }]}
						fieldProps={{
							addonAfter: "USD"
						}}
					/>
				</div>
			);
		}
		
		if (ruleActionValue[1] === "conversion_bid:inc:$" || ruleActionValue[1] === "conversion_bid:dec:$") {
			return (
				<div className="budget-input">
					<ProFormText
						label={t("竞价值")}
						name="value"
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
						precision={2}
						min={0.01}
						value={ruleActionParamValue?.value}
						onChange={({target:{value}}) => {
							setRuleActionParamValue({...ruleActionParamValue, value:value})}
						}
						rules={[{ required: true, message: t("请输入数值") }]}
					/>
						<ProFormText
						label={t("竞价下限值")}
						name="min"
						// placeholder={t("automatedRules.editStrategy.action.message")}
						placeholder={t("请输入数值")}
						style={{ width: "100%", marginTop: "10px" }}
						precision={2}
						min={0.01}
						value={ruleActionParamValue?.min}
						onChange={({target:{value}}) => {
							setRuleActionParamValue({...ruleActionParamValue, min:value})}
						}
						rules={[{ required: true, message: t("请输入竞价下限值") }]}
					/>
				</div>
			);
		}
		if (ruleActionValue[1] === "conversion_bid:new:") {
			form.setFieldsValue({max:999999})

			return (
				<div >
					<div className="budget-input">
						<ProFormSelect
							label={t("调整目标")}
							name="target"
							options={[
								{ label: "广告花费回报 (ROAS)-移动应用购物", value: "ROAS_MOBILE_APP_SHOPPING" },
								{ label: "广告花费回报 (ROAS)-网站购物", value: "ROAS_WEBSITE_SHOPPING" },
								{ label: "单次移动应用安装费用", value: "COST_PER_MOBILE_APP_INSTALL" },
								{ label: "单次移动应用购物费用", value: "COST_PER_MOBILE_APP_SHOPPING" },
								{ label: "单次购物费用(Meta Pixel 像素代码)", value: "COST_PER_SHOPPING_META_PIXEL" },
								{ label: "单次线下购物费用", value: "COST_PER_OFFLINE_SHOPPING" },
								{ label: "单次成效费用", value: "COST_PER_CONVERSION" },
								{ label: "千次展示费用", value: "COST_PER_THOUSAND_IMPRESSIONS" },
								{ label: "CPA", value: "CPA" },
								{ label: "CPC", value: "CPC" }
							]}
							placeholder={t("请选择调整目标")}
							style={{ width: "100%", marginTop: "10px" }}
							value={ruleActionParamValue?.target}
							onChange={value => setRuleActionParamValue({...ruleActionParamValue, target:value})}
							rules={[{ required: true, message: t("请选择调整目标") }]}
						/>
						<ProFormText
							label={t("目标值")}
							name="value"
							// placeholder={t("automatedRules.editStrategy.action.message")}
							placeholder={t("请输入目标值")}
							style={{ width: "100%", marginTop: "10px" }}
							precision={2}
							min={0.01}
							value={ruleActionParamValue?.value}
							onChange={({target:{value}}) => {
								setRuleActionParamValue({...ruleActionParamValue, value:value})}
							}
							rules={[{ required: true, message: t("请输入目标值") }]}
						/>
					</div>
					<div>
						<ProFormItem label={t("手动竞价范围")} rules={[{ required: true, message: t("请输入预算范围") }]} name="budgetRange">
						<Space direction="horizontal" size={16}>
							<ProFormText
							name="min"
								placeholder={t("请输入数值")}
								style={{ width: "100%", marginTop: "10px" }}
								fieldProps={{
									min: 0,
									max: 999999,
									defaultValue: 999999,
									
										addonAfter: "USD",
									
									onChange: (e) => {
										const minValue = parseFloat(e.target.value);
										const maxValue = form.getFieldValue('max');
										if (minValue < maxValue) {
											
											form.setFieldsValue({ budgetRange:minValue+":"+maxValue})
											setRuleActionParamValue({...ruleActionParamValue, min:value})
										}
										if(!minValue){
											form.setFieldsValue({ budgetRange:null});
										}
									}
								}}
								rules={[{ required: true, message: t("请输入最小值") }]}
							
							/>
							<span style={{borderBottom:"2px solid #999",display:"inline-block",width:"12px",paddingBottom:"10px",marginBottom:'20px'}}></span>

							<ProFormText
								name="max"
								placeholder={t("请输入最大值")}
								style={{ width: "100%", marginTop: "10px" }}
								fieldProps={{
									min: 0,
									max: 999999,
									defaultValue: 999999,
									addonAfter: "USD",
									onChange: (e) => {
										const maxValue = parseFloat(e.target.value);
										const minValue = form.getFieldValue('min');
										if (maxValue > minValue) {
											form.setFieldsValue({ budgetRange:minValue+":"+maxValue})
											setRuleActionParamValue({...ruleActionParamValue, max:value})
										}
										if(!maxValue){
											form.setFieldsValue({ budgetRange:null});
										}
									}
								}}
								rules={[{ required: true, message: t("请输入最大值") }]}
							
							/>
						</Space>
						</ProFormItem>
					</div>
				</div>
			);
		}

	};

	const handleReset = () => {
		setInitValue({enable_time_range: ["00:00:00", "23:59:59"],
			reportPeriod: "TODAY"})
			form.resetFields(['strategyName','advIds'])
			console.log("initRinitValueule",initValue)
		
			setQueryBuilderTree(QbUtils.loadTree(defaultQueryBuilderValue));
			setQueryBuilderTree(loadFromTreeForGo(JSON.parse(initRule),conatants));

			setRuleActionValue(undefined);
			setRuleActionParamValue(undefined);
			setActionParamInputDisplay(false);
		}


	return (
		<Spin tip="loading" spinning={spinning}>
			{!spinning && (
				<PageContainer>
					<ProForm
						layout="vertical"
						style={{ background: "white", padding: "20px", width: "auto" }}
						// onFinish={onFinish}
						initialValues={{
							advIds: initValue.advIds
						}}
						submitter={false}
						form={form}
					
					>
						{/* <div className="editRuleInfo">
							<span>
								<InfoOutlined style={{ borderRadius: "50%", background: "#FFAF41", color: "#fff", marginRight: 5 }} />
								{t("automatedRules.manageRules.tip")}
							</span>
						</div> */}
						<ProFormText
							name="strategyName"
							initialValue={initValue.strategy_name}
							label={t("automatedRules.actionHistory.table.column2")}
							placeholder={t("automatedRules.editStrategy.strategyName.placeholder")}
							rules={[
								{
									required: true,
									message: t("automatedRules.editStrategy.strategyName.placeholder")
								}
							]}
						/>

						<ProFormItem label={t("automatedRules.editStrategy.adv.label")} required>
							<div className="advContainer">
								<div className="advDescribe">
									{t("automatedRules.editStrategy.adv.desc", { count: currentUser?.currentPlan?.ruleActivationLimit || 0 })}
								</div>
								<div className="advSelect">
									<ProFormSelect
										options={advOptions}
										showSearch
										name="advIds"
										mode="multiple"
										rules={[
											{
												required: true,
												message: "Please select at least one ad account"
											}
										]}
										fieldProps={{
											labelInValue: true,
											maxCount: 20,
											fieldNames: {
												label: "advName",
												value: "advId"
											}
											// labelRender: item => {
											// 	if (item?.label) {
											// 		return item.label;
											// 	}
											// }
										}}
									/>
								</div>
							</div>
						</ProFormItem>

						<ProFormRadio.Group
							required
							name="scope"
							initialValue={initValue.scope}
							label={t("automatedRules.editStrategy.latitude.label")}
							radioType="button"
							options={[
								{
									label: t("automatedRules.editStrategy.latitude.camapign"),
									value: "campaign"
								},
								{
									label: t("automatedRules.editStrategy.latitude.adgroup"),
									value: "adgroup"
								},
								{
									label: t("automatedRules.editStrategy.latitude.ad"),
									value: "ad"
								}
							]}
							fieldProps={{
								onChange: ({ target: { value } }) => {
									scopeChange(value);
								}
							}}
							rules={[
								{
									required: true,
									message: t("strategy.latitude.errorMessage")
								}
							]}
						/>

						<ProFormRadio.Group
							required
							name="scopeStatus"
							initialValue={initValue.scope_status}
							label={t("automatedRules.editStrategy.apply rule to")}
							radioType="button"
							options={[
								{
									label: t("automatedRules.editStrategy.Active"),
									value: "STATUS_DELIVERY_OK"
								},
								{
									label: t("automatedRules.editStrategy.Inactive"),
									value: "STATUS_DISABLE"
								}
								// {
								// 	label: t("strategy.scope.STATUS_NOT_DELIVERY"),
								// 	value: "STATUS_NOT_DELIVERY"
								// },
								// {
								// 	label: t("strategy.scope.STATUS_NOT_DELETE"),
								// 	value: "STATUS_NOT_DELETE"
								// }
							]}
							rules={[
								{
									required: true,
									message: t("strategy.scope.errorMessage")
								}
							]}
						/>

						<ProFormTimePicker.RangePicker
							required
							tooltip={t("automatedRules.editStrategy.timeRange.toolTip")}
							name="enableTimeRange"
							label={t("automatedRules.editStrategy.timeRange")}
							dataFormat="HH:mm:ss"
							initialValue={[
								dayjs(initValue.enable_time_range[0], "HH:mm:ss"),
								dayjs(initValue.enable_time_range[1], "HH:mm:ss")
							]}
							rules={[
								{
									required: true
								}
							]}
						/>
						<ProFormRadio.Group
							required
							name="isPepetitive"
							initialValue={initValue.is_repetitive}
							label={t("automatedRules.editStrategy.repeat")}
							radioType="button"
							options={[
								{
									label: t("automatedRules.editStrategy.repeat.all time"),
									value: 1
								},
								{
									label: t("automatedRules.editStrategy.repeat.once"),
									value: 0
								}
							]}
							rules={[
								{
									required: true
									// message: t("strategy.repeat.errorMessage")
								}
							]}
						/>
						<ProFormSelect
							required
							tooltip={t("automatedRules.actionHistory.table.column8.tooltip")}
							name="reportPeriod"
							initialValue={initValue.reportPeriod}
							label={t("automatedRules.actionHistory.table.column7")}
							options={[
								{
									label: t("最大范围"),
									value: "MAXIMUM"
								},
								{
									label: t("今天"),
									value: "TODAY"
								},
								{
									label: t("昨天"),
									value: "YESTERDAY"
								},
								{
									label: t("本月"),
									value: "THIS_MONTH"
								},
								{
									label: t("上月"),
									value: "LAST_MONTH"
								},
								{
									label: t("本季度"),
									value: "THIS_QUARTER"
								},
								{
									label: t("过去3天"),
									value: "MAXIMUM"
								},
								{
									label: t("过去3天"),
									value: "LAST_3D"
								},
								{
									label: t("过去7天"),
									value: "LAST_7D"
								},
								{
									label: t("过去14天"),
									value: "LAST_14D"
								},
								{
									label: t("过去28天"),
									value: "LAST_28D"
								},
								{
									label: t("过去30天"),
									value: "LAST_30D"
								},
								{
									label: t("过去90天"),
									value: "LAST_90D"
								},
								{
									label: t("上周（周一到周日）"),
									value: "LAST_WEEK_MON_SUN"
								},
								{
									label: t("上周（周日到周六）"),
									value: "LAST_WEEK_SUN_SAT"
								},
								{
									label: t("上季度"),
									value: "LAST_QUARTER"
								},
								{
									label: t("去年"),
									value: "LAST_YEAR"
								},
								{
									label: t("本周（周一到今天）"),
									value: "THIS_WEEK_MON_TODAY"
								},
								{
									label: t("本周（周日到今天）"),
									value: "THIS_WEEK_SUN_TODAY"
								},
								{
									label: t("今年"),
									value: "THIS_YEAR"
								}
							]}
							rules={[
								{
									required: true,
									message: t("strategy.reportPeriod.errorMessage")
								}
							]}
						/>
						<ProFormText
							disabled
							// name="frequency"
							label={t("automatedRules.editStrategy.run.schedule.label")}
							value={t("automatedRules.editStrategy.run.schedule.value", { minuts: currentUser?.currentPlan?.ruleFrequency || 5 })}
						/>
						<ProFormDependency name={["scope"]}>
							{({ scope }) => {
								let newFields11 = handleChangeScope(scope);

								return (
									<ProFormItem
										required
										initialValue={queryBuilderTree}
										name="querytree"
										label={t("automatedRules.editStrategy.condition")}
									>
										<Query
											{...queryBuilderConfig}
											fields={{ ...newFields11 }}
											value={queryBuilderTree}
											renderBuilder={queryBuilderRenderBuilder}
											onChange={onQueryBuilderChange}
										/>
									</ProFormItem>
								);
							}}
						</ProFormDependency>

						<ProFormDependency name={["scope"]}>
							{({ scope='campaign' }) => {
								let scopRuleActionOptions = handleChangeActionScope(scope);
								return (
									<ProFormItem required label={t("automatedRules.editStrategy.action")}>
										<Cascader
											style={{ width: "100%" }}
											options={[...scopRuleActionOptions]}
											value={ruleActionValue}
											onClear={() => console.log(11111)}
											onChange={value => {
										
												const optionGroup = scopRuleActionOptions.find(item => value?.[0] === item.value);
												if (optionGroup && optionGroup.needExtraParam) {
													setActionParamInputDisplay(true);
												} else {
													setActionParamInputDisplay(false);
													setRuleActionParamValue(undefined);
												}
												setRuleActionValue(value);

												if (optionGroup && optionGroup.needBudgetUpperLimit) {
													setNeedBudgetUpperLimit(true);
												} else {
													setNeedBudgetUpperLimit(false);
												}
											}}
										/>

										{renderBudget()}
									</ProFormItem>
								);
							}}
						</ProFormDependency>
					</ProForm>

					<div className="createRuleFooter">
						<Space>
							<Button onClick={() => navigator("/Automated/manage")}>{t("action.button.back")}</Button>
							<Button onClick={() => handleReset()}>{t("action.button.reset")}</Button>
							<Button className="Submit" onClick={() => onFinish()}>
								{t("action.button.submit")}
							</Button>
						</Space>
					</div>
				</PageContainer>
			)}
		</Spin>
	);
};

export default RuleEdit;
